export default function getFlowStage(state) {
  if (state.loginForm && state.loginForm.flowStage) {
    return state.loginForm.flowStage;
  }
  return null;
}